// The turns still streaming and the sessions still loading, per customer, so
// clearing the session or unloading the customer can stop them: a turn that
// kept streaming would write itself back into a store that was just emptied,
// and keep the model running; a load would bring back the session just cleared.
const controllersByCustomerId = new Map();

export function startRequest(customerId) {
  const controller = new AbortController();
  if (!controllersByCustomerId.has(customerId)) {
    controllersByCustomerId.set(customerId, new Set());
  }
  controllersByCustomerId.get(customerId).add(controller);
  return controller;
}

export function finishRequest(customerId, controller) {
  const controllers = controllersByCustomerId.get(customerId);
  if (!controllers) {
    return;
  }
  controllers.delete(controller);
  if (controllers.size === 0) {
    controllersByCustomerId.delete(customerId);
  }
}

export function abortRequests(customerId) {
  const controllers = controllersByCustomerId.get(customerId);
  if (!controllers) {
    return;
  }
  controllersByCustomerId.delete(customerId);
  controllers.forEach(controller => controller.abort());
}
